import React, { useEffect, useRef, useState } from "react";
import logoimg from "../components/images/logo.PNG";
import {
  AiOutlineShoppingCart,

} from "react-icons/ai";



import { Link, NavLink } from "react-router-dom";
import CartComponentModal from "./CartComponentModal";

const NavbarComponent = (props) => {
  const [showList, setshowList] = useState(false);
  const [showSidebar, setshowSidebar] = useState(false);


  const match = props.auth.userRoles?.includes("5150");


  const handleSidebar = () => {
    setshowList(!showList);
  };






  const subtotal = props.cart.reduce((a, c) => a + c.quantity * c.price, 0);

  return (
    <>
      <div>
        <nav className="flex items-center bg-teal-400 justify-between pl-5 pr-5 pt-2 pb-2 sticky top-0 ">
          <ul className="flex items-center space-x-5 ">
            <NavLink to="/">
              <div className="bg-teal-500 text-white px-2 py-1 text-sm rounded-md">
                U.K. Polo
              </div>
            </NavLink>
            <NavLink to="/tshirts">
              <li className="font-semibold text-white cursor-pointer text-sm hover:text-teal-700 pt-2">
                Tshirts
              </li>
            </NavLink>

            <NavLink to="/orders">
              <li className="font-semibold cursor-pointer text-sm text-white hover:text-teal-700 pt-2">
                Orders
              </li>
            </NavLink>
            {match ? (
              <NavLink to="/admin/dashboard">
                <li className="font-semibold cursor-pointer text-sm text-white hover:text-teal-700 pt-2">
                  Admin
                </li>
              </NavLink>
            ) : (
              <span></span>
            )}
          </ul>
          <ul className="flex space-x-5 items-center">
            <li className="cursor-pointer pt-2">
              {!props.auth.isAuthenticated ? (
                <Link to="/login">
                  <button className="bg-teal-600 text-white px-2 py-1 text-sm rounded-md">
                    Login
                  </button>{" "}
                </Link>
              ) : (
                <>
                  {" "}
                  <p
                    className="cursor-pointer font-bold text-teal-900 text-lg"
                    onClick={() => handleSidebar()}
                  >
                    Hi {props.auth.creds.name}
                  </p>
                </>
              )}
            </li>
            <li className="cursor-pointer pt-2">
              <AiOutlineShoppingCart
                onClick={() => setshowSidebar(true)}

                className="text-2xl"
              />
            </li>
          </ul>
        </nav>
      </div>

      {props.auth.isAuthenticated && showList && (
        <div className="absolute right-10 top-10 bg-teal-600 py-1 px-2 text-white z-50">
          <Link to="/profile">
            <p
              className="cursor-pointer border-b-2 border-teal-800 pb-0.5"
              onClick={() => handleSidebar()}
            >
              My Accounts
            </p>
          </Link>
          <Link to="/orders">
            {" "}
            <p
              className="cursor-pointer border-b-2 border-teal-800 pb-0.5"
              onClick={() => handleSidebar()}
            >
              My Orders
            </p>
          </Link>
          <p className="cursor-pointer" onClick={() => props.logoutUser()}>
            Logout
          </p>
        </div>

      )}
      {showSidebar ? <CartComponentModal onClick={(value) => setshowSidebar(value)} handleOrderFailed={props.handleOrderFailed} subtotal={subtotal} clearCart={props.clearCart} removeFromCart={props.removeFromCart} addItemsToCart={props.addItemsToCart} cart={props.cart} />

        : <></>}
    </>
  );
};

export default NavbarComponent;
